import React, {useEffect, useState} from 'react';
import {InvalidPanel, ThemedButton, ThemedDialog, ThemedInput} from "../../../../index";
import {useTheme} from "../../../../../common/ProjectThemeProvider";
import {checkNullJson, checkNullStr, getJsonValue, isBoolTrue, isJsonValueTrue} from "../../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, printError, printLog, sendRequest} from "../../../../utils/AppUtils";
import {useToast} from "../../../../../common/fusion-ui/provider/ToastProvider";
import {ModuleFieldsData, Modules, ReqUrls,} from "../../../../config/AppConfig";
import {Flexbox} from "../../../../../common/fusion-ui";
import {CssVariant, Messages} from "../../../../../common/fusion-ui/config/FusionConfig";
import {useInternetStatus} from "../../../../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../../../../common/CommonConfig";

const Img_CreateAlbum_FormDialog = ({
                                        updateOnly,
                                        updateRecordId,
                                        open,
                                        onHide,
                                        onCancel,
                                        onSuccess,
                                        onFailure,
                                    }) => {
    const TAG = "Img_CreateAlbum_FormDialog";

    const moduleName = Modules.Images;
    const FormFields = ModuleFieldsData[moduleName];

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const FOCUS_DELAY = 2000;

    const Fields = {
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        updateRecordId: 'updateRecordId',
        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',
    };
    const [fieldsData, setFieldsData] = useState({});
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        clearPanelData();
        // log('useEffect.updateOnly:', updateOnly, 'updateRecordId:', updateRecordId);

        if (isUpdateMode()) {
            fetchEditModeData(updateRecordId);
        } else {
            updateField(Fields.isDataLoading, false);
            updateField(Fields.isDataFound, true);
            updateField(Fields.dataLoadingMsg, '');
        }
    }, [updateOnly, updateRecordId]);

    return (<>
        <ThemedDialog
            open={isBoolTrue(open)}
            title={getTabTitle()}
            widthClass={'col-sm-10 col-md-5'}
            showClose={false}
            showFooter={false}
            closeOnEscape={true}
            closeOnOutsideClick={false}
            onHide={() => {
                if (onHide) onHide();
                clearPanelData();
            }}
            onEscapeClose={() => {
                if (onCancel) onCancel();
                clearPanelData();
            }}
            // onOutsideClick={onCancel}
        >
            <div className={'px-2'}>
                {/*<div>*/}
                {/*    <div>updateOnly: {jsonToStr(updateOnly)}</div>*/}
                {/*    <div>updateRecordId: {jsonToStr(updateRecordId)}</div>*/}
                {/*</div>*/}
                {isUpdateMode() && <InvalidPanel
                    wrapperClassName={''}
                    labelClassName={'m-2 w-100 fs-normal'}
                    color={theme.text70}
                    success={isFieldTrue(Fields.isDataFound)}
                    loading={isFieldTrue(Fields.isDataLoading)}
                    msg={getField(Fields.dataLoadingMsg)}
                    show404Image={true}
                />}

                {(!isUpdateMode() || (isUpdateMode() && (!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound)))) &&
                    <div className={'px-2'}>
                        <div>
                            {/*albumName*/}
                            <ThemedInput
                                wrapperClassName={''}
                                className={''}
                                label={FormFields.albumName.title}
                                placeholder={FormFields.albumName.title}
                                id={FormFields.albumName.column}
                                type={'text'}
                                value={getFormField(FormFields.albumName)}
                                msg={getFormFieldMsg(FormFields.albumName)}
                                required={true}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    updateFormField(FormFields.albumName, value);
                                    if (checkNullStr(value)) updateFormFieldMsg(FormFields.albumName, '');
                                }}
                            />

                            {/*albumDesc*/}
                            <ThemedInput
                                wrapperClassName={''}
                                className={''}
                                label={FormFields.albumDesc.title}
                                placeholder={FormFields.albumDesc.title}
                                id={FormFields.albumDesc.column}
                                type={'text'}
                                value={getFormField(FormFields.albumDesc)}
                                msg={getFormFieldMsg(FormFields.albumDesc)}
                                required={true}
                                asTextArea={true}
                                style={{
                                    height: '80px',
                                    minHeight: '80px',
                                    maxHeight: '80px'
                                }}
                                showLimitLabel={true}
                                maxLength={62.5}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    updateFormField(FormFields.albumDesc, value);
                                    if (checkNullStr(value)) updateFormFieldMsg(FormFields.albumDesc, '');
                                }}
                            />
                        </div>

                        {/*footer*/}
                        <div className={'mt-1 mb-3'}>
                            {/*controls*/}
                            <Flexbox className={'mt-2'} justifyAt={'center'} alignAt={'center'}>
                                {/*cancel*/}
                                <ThemedButton
                                    className={'rounded-2 w-auto px-4 py-1'}
                                    text={'Cancel'}
                                    variant={theme.text10}
                                    hoverBgColor={theme.text30}
                                    color={theme.text}
                                    onClick={() => {
                                        if (onCancel) onCancel();
                                        if (onHide) onHide();
                                        clearPanelData();
                                    }}
                                    mx={2}
                                />

                                {/*submit*/}
                                <ThemedButton
                                    className={'rounded-2 w-auto px-4 py-1'}
                                    text={isFieldTrue(Fields.submitBtn_AsLoading)
                                        ? isUpdateMode() ? 'Updating...' : 'Creating...'
                                        : isUpdateMode() ? 'Update' : 'Create'}
                                    variant={theme.primaryBlue}
                                    hoverBgColor={theme.primaryBlueDark}
                                    loadingWidth={'auto'}
                                    asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                                    disabled={isFieldTrue(Fields.submitBtn_disabled)}
                                    onClick={handleSubmit}
                                    mx={2}
                                />
                            </Flexbox>
                        </div>
                    </div>}
            </div>
        </ThemedDialog>
    </>)

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    formData: formData,
                    recordId: updateRecordId,
                    updateOnly: isUpdateMode(),
                };
                sendRequest({
                    reqUrl: ReqUrls.img__addEditAlbum_submitFormData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');
                        const alreadyExists = isJsonValueTrue(fetchedData, 'alreadyExists');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        updateField(Fields.submitBtn_AsLoading, false);
                        if (success && !alreadyExists) {
                            toast(message, CssVariant.success);
                            if (onSuccess) onSuccess(fetchedData, message, formData);
                            clearPanelData();

                            setFieldsData({});
                            setFormData({});
                            setFormFieldsMsgs({});
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                            if (onFailure) onFailure(fetchedData, message);
                        }
                        if (onHide) onHide();
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchEditModeData(recordId) {
        const fun = 'fetchEditModeData:';
        try {
            log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));

            // if (!isFieldTrue(Fields.isUpdateFormDataFetched)) {
            updateField(Fields.isUpdateFormDataFetched, true);
            updateField(Fields.updateRecordId, recordId);
            if (checkNullStr(recordId)) {
                updateField(Fields.isDataLoading, true);
                updateField(Fields.dataLoadingMsg, "");

                //send-request
                const REQUEST_OPTIONS = {
                    recordId: recordId,
                };
                sendRequest({
                    reqUrl: ReqUrls.img__album_addEditPage_fetch_editFormData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                        const success = checkNullJson(fetchedFormData);

                        updateField(Fields.isDataFound, success);
                        if (success) {
                            // toast('Successfully fetched your data.', CssVariant.success);
                            setFormData(fetchedFormData);
                        } else {
                            updateField(Fields.dataLoadingMsg, "Invalid record id!");
                        }
                        updateField(Fields.isDataLoading, false);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        updateField(Fields.dataLoadingMsg, Messages.fetchError);
                        updateField(Fields.isDataFound, false);
                        updateField(Fields.isDataLoading, false);
                    }),
                });
            } else {
                updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
            // }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function clearPanelData() {
        setFormData({});
        setFormFieldsMsgs({});
        setFieldsData({});
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            FormFields.albumName,
            FormFields.albumDesc,
        ];

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            focusIdField(colField.column);
        }
        return verified;
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function getTabTitle() {
        return isUpdateMode() ? `Edit album` : `Create new album`;
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
};
export default Img_CreateAlbum_FormDialog;
